import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { InstallationWebSocketMetric } from "@/model/data/networkMetrics/InstallationWebSocketMetric";

export class FetchInstallationNetworkMetricsResData extends ApiGenericResponse {
    installationsList: InstallationWebSocketMetric[];
    totalInstallationsCount: number = 0;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.InstallationsList) {
            this.installationsList = new Array();
            obj.InstallationsList.forEach((element) => {
                let installationMetric = new InstallationWebSocketMetric();
                installationMetric.parse(element);
                this.installationsList.push(installationMetric);
            });
        }
        if (obj.TotalInstallationsCount != null && obj.TotalInstallationsCount != undefined) this.totalInstallationsCount = obj.TotalInstallationsCount;
    }
}
